<template>
  <div class="incubate">
    <common-layout>
      <div slot="header">
        <div class="incubate-tabs">
          <span
            v-for="(item,index) in tabs"
            :key="item.id"
            @click="handleClick(item.id)"
            :class="{'active_t':active== item.id}"
          >
            {{item.name}}
          </span>
        </div>
        <ul class="incubate-nav">
          <li>科技资源</li>
          <li class="+active-Tab">孵化平台</li>
        </ul>
      </div>
      <div slot="container">
        <IncubatedEnterprises v-if="active == 1"></IncubatedEnterprises>
        <HandlingIncubation v-else-if="active == 2"></HandlingIncubation>
        <!-- <PolicyFormation v-else-if="active == 3"></PolicyFormation> -->
        <Area v-else-if="active == 4" />
      </div>
    </common-layout>
  </div>
</template>

<script type="text/ecmascript-6">
import CommonLayout from "../../../components/common-layout.vue";
import IncubatedEnterprises from "./IncubatedEnterprises";
import HandlingIncubation from "./HandlingIncubation";
import PolicyFormation from "./PolicyFormation";
import Area from "./area";
export default {
  components: {
    CommonLayout,
    IncubatedEnterprises,
    HandlingIncubation,
    PolicyFormation,
    Area
  },
  data() {
    return {
      active: 1,
      tabs: [
        {
          id: 1,
          name: "入孵企业（团队）名录"
        },
        {
          id: 2,
          name: "入孵线上办理"
        },
        // {
        //   id: 3,
        //   name: "政策信息"
        // },
        {
          id: 4,
          name: "孵化场地管理"
        },
      ]
    };
  },
  methods:{
    // 切换tab
			handleClick(val) {
				this.active = val;
			}
  }
};
</script>

<style scoped lang="scss">
.incubate {
  height: 100%;
  .incubate-tabs {
    // width: 452px;
    height: 50px;
    border: 1px solid #ef9f49;
    display: flex;
    border-radius: 50px;
    overflow: hidden;
    cursor: pointer;

    > span {
      display: inline-block;
      width: 150px;
      height: 50px;
      line-height: 50px;
      font-weight: bold;

      &.active_t {
        background: linear-gradient(to bottom right, #fbc434 0%, #f66b4e 100%);
        color: #fff;
      }
    }
  }
  .policey_nav {
    display: flex;
    align-items: center;
    justify-content: space-between;

    li {
      &.active-Tab {
        color: rgba(255, 255, 255, 0.4);

        &:before {
          display: inline-block;
          padding-right: 0.5rem;
          padding-left: 0.5rem;
          color: rgba(255, 255, 255, 0.4);
          content: "/";
        }
      }
    }
  }
}
</style>
